import { createApp } from 'vue';
import XAlert from './x-alert.vue';

const getPortal = () => {
  const check = document.querySelector('.x-alert-root');
  if (check) {
    return check;
  }
  const el = document.createElement('div');
  el.classList.add('x-alert-root');
  document.body.appendChild(el);
  return el;
};

export interface IAlertFunctionOptions {
  icon: string;
  message: string;
  duration?: number;
}

export const alert = (option: IAlertFunctionOptions) => {
  const instance = createApp(XAlert, {
    icon: option.icon,
    message: option.message,
  });

  instance.mount(getPortal());

  setTimeout(() => {
    instance.unmount();
  }, option.duration || 1500);
};

export default {
  success: (message: string, params?: Omit<IAlertFunctionOptions, 'icon' | 'message'>) =>
    alert({
      message,
      icon: 'm-success',
      ...params,
    }),
  error: (message: string, params?: Omit<IAlertFunctionOptions, 'icon' | 'message'>) =>
    alert({
      message,
      icon: 'm-error',
      ...params,
    }),
};
